import React, { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import './EditCalendar.css'; // Import the custom CSS file
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { set } from 'date-fns';

const EditCalendar = ({ name, onChange, value, readOnly }: { name?: string, onChange?: any, value: any[], readOnly?: boolean }) => {
    const [selected, setSelected] = React.useState<any[] | undefined>();
    const [startDate, setStartDate] = useState(new Date());
    const [showList, setShowList] = useState(false);
    const [accValue, setAccValue] = useState<string | undefined>(undefined);

    useEffect(() => {
        // map the selected timestamp dates to Date objects
        if (value) {
            const dates = value.map((date: any) => {
                console.log(date);
                try {
                    return date || null;
                } catch (e) {
                    return Date.parse(date) ? new Date(date) : null;
                }
            })
            setSelected(dates);
        } else {
            setSelected([]);
        }
    }, [value]);

    const handlePrev = () => {
        setStartDate(new Date(startDate.getFullYear() - 1, startDate.getMonth()));
    };

    const handleNext = () => {
        setStartDate(new Date(startDate.getFullYear() + 1, startDate.getMonth()));
    };

    const handleThisMonth = () => {
        setStartDate(new Date());
    };

    const handleListDateClick = (date: Date) => {
        setStartDate(date);
        setShowList(false);
    };

    const handleSelectionChanged = (selection: any[] | undefined) => {
        if (!selection) return;
        selection.sort((a, b) => a.getTime() - b.getTime());
        setSelected(selection);
        if (!readOnly) {
            if (onChange) onChange({ name: name, value: selection });
        }

    };

    const calendarRenderer = (start: Date) => {
        return (
            <DayPicker
                mode="multiple"
                month={start}
                weekStartsOn={1}
                numberOfMonths={12}
                selected={selected}
                onSelect={(sel: Date[] | undefined) => handleSelectionChanged(sel)}
            />
        );
    };

    const firstDate = () => {
        return selected && selected.length > 0 ? new Date(selected[0].seconds * 1000).toDateString() : 'unknown';
    };

    const latestDate = () => {
        return selected && selected.length > 0 ? new Date(selected[selected.length - 1].seconds * 1000).toDateString() : 'unknown';
        return '';
    };

    const stateRenderer = () => {
        return (
            <Dialog open={showList}>
                <DialogContent>
                    <DialogTitle>You have currently selected:</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {selected?.map((date, index) => (
                                <div key={index}>
                                    <li
                                        className="text-blue-700 underline cursor-pointer"
                                        onClick={() => handleListDateClick(date)}
                                    >
                                        {date.toDateString()}
                                    </li>
                                </div>
                            ))}
                        </DialogContentText>
                    </DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowList(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    };

    const labelRenderer = () => {
        return (
            <div className="font-bold">
                Selected {selected?.length || 0} dates
                {selected && selected.length > 0 && (
                    <>, starting on {firstDate()} </>
                )}
                {selected && selected.length > 1 && (
                    <>, ending on {latestDate()} </>
                )}
            </div>
        )
    }

    return (

        (readOnly ?
            <div className='w-60'>{labelRenderer()}</div> :
            <>
                <Accordion
                    type="single"
                    collapsible
                    value={accValue}
                    onValueChange={(value) => {
                        if (value === accValue) {
                            setAccValue(undefined);
                        } else {
                            setAccValue(value);
                        }
                    }}
                >
                    <AccordionItem
                        value="calendar-accordion-item"
                        className={(accValue && accValue.length > 0) ? '' : 'w-[300px]'}
                    >
                        <AccordionTrigger>
                            {labelRenderer()}
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className="border ml-4 flex p-3 bg-slate-300 w-[330px]">
                                <Button className="bg-white" onClick={handlePrev}>
                                    Previous year
                                </Button>
                                <div
                                    className="m-2 mt-[2px] text-2xl cursor-pointer"
                                    onClick={handleThisMonth}
                                >
                                    {startDate.getFullYear()}
                                </div>
                                <Button className="bg-white" onClick={handleNext}>
                                    Next year
                                </Button>
                            </div>
                            <div
                                className="w-[330px] ml-4 bg-slate-200 cursor-pointer underline underline-offset-2 text-blue-500 p-3"
                                onClick={() => setShowList(true)}
                            >
                                Show selected dates ({selected?.length || 0})
                            </div>
                            <div className="day-picker-container flex flex-wrap">
                                {calendarRenderer(startDate)}
                            </div>

                            {stateRenderer()}
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </>
        )
    );
};

export default EditCalendar;